import { instance, instanceNoToken } from './ajax.js'

//用户
export const UserApi = {
    login(params) {
        return instanceNoToken.post('/api/userApi/getLogin',params)
    },
    // 续费设备
    getFacilityList( params ) {
        return instance.get('/api/facility/getFacilityList',{ params } )
    },
    // 用户信息
    getUserInfo(params) {
        return instance.post('/api/userApi/getUserInfo?userId=' + params.userId )
    },
    // 当前用户信息
    getCurrentUserInfo(params) {
        return instance.post('/api/userApi/getCurrentUserInfo?userId=' + params.userId )
    },

    //登录用户信息
    getLoginUserInfo(params) {
        return instance.post('/api/userApi/getLoginUserInfo?userId=' + params.userId )
    },
    // 修改客服电话
    updateTel(params) {
        return instance.put('/api/oper/updateTel', { params } )
    },
    // 获取权限
    userMenuTreeselect(params) {
        return instance.get('/api/userApi/userMenuTreeselect/' + params.id)
    },
    // 通知开关
    updateStatus(params) {
        return instance.post('/api/oper/updateStatus?operatorId=' + localStorage.getItem('operatorId'), params)
    },
    getStatus(params) {
        return instance.post('/api/oper/getOpenStatus?operatorId=' + localStorage.getItem('operatorId'), params)
    },
    updateOpenId(params) {
        return instance.post('/api/oper/updateOpenId', params)
    },
    getYue(params) {
        return instance.get('/api/oper/getYue', { params })
    },
    updatePwd(params) {
        return instanceNoToken.post('/api/userApi/updatePwd',params)
    }
}
// 首页
export const HomeApi = {
    selectInComeInfo() {
        return instance.get('/api/goodsOrder/selectInComeInfo')
    },
    selectFacilityInfo() {
        return instance.get('/api/goodsOrder/selectFacilityInfo')
    },
    //统计汇总
    selectHotSaleH5Total(params, config) {
        return instance.get('/api/goodsOrder/selectHotSaleH5Total', { params, headers: {
            ...config
        } })
    },
    //热销商品
    selectHotSaleGoodsH5(params, config) {
        return instance.get('/api/goodsOrder/selectHotSaleGoodsH5', { params, headers: {
            ...config
        } })
    },
    //热销商品明细
    selectHotSaleGoodsH5Detail(params, config) {
        return instance.get('/api/goodsOrder/selectHotSaleGoodsH5Detail', { params, headers: {
            ...config
        } })
    },
    //热销设备
    selectHotSaleFacilityH5(params, config) {
        return instance.get('/api/goodsOrder/selectHotSaleFacilityH5', { params, headers: {
            ...config
        } })
    },
    //热销设备明细
    selectHotSaleFacilityH5Detail(params, config) {
        return instance.get('/api/goodsOrder/selectHotSaleFacilityH5Detail', { params, headers: {
            ...config
        } })
    },
    //近七日收入
    selectWeekInComeH5() {
        return instance.get('/api/goodsOrder/selectWeekInComeH5')
    },
    expriceFacility(params) {
        return instance.get('/api/facility/expriceFacility', { params } )
    }
}
//商品
export const GoodsApi = {
    selectGoodsByOp(params, pam) {
        return instance.get('/api/track/selectGoodsByOp/'+ params.type, { params: pam })
    },
    goodsList(params) {
        return instance.get('/api/goodsOperator/getIGoodsOperatorList', { params })
    },
    goodsInfo(params){
        return instance.get('/api/goodsOperator/getGoodsInfo/'+params.id)
    },
    getGoodsOperatorInfo(params) {
        return instance.get('/api/goodsOperator/getGoodsOperatorInfo/'+params.id)
    },
    //修改商品
    goodsUpdate(params){
        return instance.post('/api/goodsOperator/putGoodsOperator',params)
    },
    goodsUpdateByAdmin(params){
        return instance.post('/api/goodsOperator/updategoodsInfo',params)
    },
    goodsInsert(params){
        return instance.post('/api/goodsOperator/selfBuiltGoods',params)
    },
    //删除商品
    apiDeleteGoodsInfoByGoodsIds(params){
        return instance.get('/api/goodsOperator/apiDeleteGoodsInfoByGoodsIds/'+params.id)
    },
    cateAll(){
        return instance.get('/api/goodsType/allType/')
    },
    cateData(params){
        return instance.post('/api/goodsType/getIGoodsTypeList',params)
    },
    addCate(params){
        return instance.post('/api/goodsType/insertOrdertype',params)
    },
    delCate(params){
        return instance.get('/api/goodsType/deleteOrdertype/',{params})
    },
    allOperator(){
        return instance.get('/api/oper/allOperator/')
    },
    goodStock(){
        return instance.get('/api/track/selectGoodsByOp/0')
    }
}

export const ApiOper = {
    getOperatorInfo(params) {
        return instance.post('/api/oper/getOperatorInfo?operatorId=' + localStorage.getItem('operatorId'), params)
    },
    renewPrice(params) {
        return instance.post('/api/facility/renewPrice',params)
    },
    // 创建续费订单
    createOrder(params) {
        return instance.post('/api/facility_order/createOrder', params )
    },
    // 续费订单拉起支付
    pullPayFacility(data) {
        return instance.post('/api/pay/pullPayFacility', data)
    },
    // 运营商续费订单拉取支付
    pullPayRecharge(data) {
        return instance.post('/api/pay/pullPayRecharge', data)
    },
    // 
    // localhost:9001/api/oper/realName?operatorId=&cardFront=&cardBack=&shopHead=&shopInside=
    realName(params) {
        return instance.post('/api/oper/realName', params)
    },
    getTimeRange(params) {
        return instance.get('/api/oper/getTimeRange', { params })
    },
    apiMerchantUrlForward(params) {
        return instance.get('/api/huifu/apiMerchantUrlForward', { params })
    }
}
export const PayApi = {
    pullPay(data) {
        return instance.post('/api/pay/pullFacilityPay', data)
    },
    getApiGetopenid(params) {
        return instance.get('/api/getoOenid/getApiGetopenid', { params })
    }
}

//公用的
export const CommonApi = {
    // api/dbType/allType
    allType() {
        return instance.get('/api/dbType/allType')
    },
    // /api/oper/allOperator
    allOperator() {
        return instance.get('/api/oper/allOperator')
    },
    updateOpenId(params) {
        return instance.post('/api/oper/updateOpenId', params)
    },
    delOpenId(params) {
        return instance.post('/api/oper/delOpenId', params)
    },
    getFacility() {
        return instance.get('/api/facility/getFacility')
    },
    getGoodsInfo() {
        return instance.get('/api/goodsOperator/getGoodsInfo')
    }
}

export const OrderApi = {
    // 订单列表
    list(params, config) {
        return instance.get('/api/goodsOrder/list', { params, headers: {
            ...config
        } })
    },
    // 订单详情
    goodsOrderInfo(params) {
        return instance.get('/api/goodsOrder/goodsOrderInfo/' + params.id)
    },
    // 退款
    getMoneyByCount(params) {
        return instance.post('/api/goodsOrder/getMoneyByCount', { params })
    },
    // 退款回显
    getOrderInfo(params) {
        return instance.get('/api/goodsOrder/getOrderInfo/' + params.id)
    },
    // 确认退款
    refundMoney(params) {
        return instance.put('/api/goodsOrder/refundMoney',  params)
    },
    // 全额退款
    refundAll(params) {
        return instance.put('/api/goodsOrder/refundAll/' + params.id )
    },
    topParam(params) {
        return instance.get('/api/goodsOrder/topParam', { params })
    }
    ,

    shoppingCar(params) {
        return instance.post('vendingApi/shoppingCar',  params)
    },
}

//首页
export const indexApi={
	//首页统计
	indexInfo(){
		return instance.get('api/goodsOrder/selectInComeInfo')
	},
	upLoad(params){
		return instance.post('api/fileUpload/upload',params)
	}
}

export const StaticApi = {
    operatorOrders(params, config) {
        return instance.get('/api/goodsOrder/operatorOrders', { params, headers: {
            ...config
        } })
    },
    facilityOrders(params, config) {
        return instance.get('/api/goodsOrder/facilityOrders', { params, headers: {
            ...config
        } })
    }
}

export const ApiBill = {
    //明细
    getAccountLog(params) {
        return instance.get('/api/oper/getAccountLog', { params })
    },
    //汇总
    getAccountLogTotal(params) {
        return instance.get('/api/oper/getAccountLogTotal', { params })
    },
    //详情
    getAccountLogInfo(params) {
        return instance.get('/api/oper/getAccountLogInfo', { params })
    }
}
